import React, { useState, useEffect, useCallback, useRef } from 'react';
import './Slider.css';

const Slider = () => {
  const slides = [
    { image: 'ERPSystem.png', text: 'Welcome to Our Company' },
    { image: 'PathFindingMachine.png', text: 'We Deliver Excellence' },
    { image: 'HRISCustomize.png', text: 'Your Trusted Partner' },
    { image: 'Advertising.png', text: 'Your Trusted Partner' },
    { image: 'Development.png', text: 'Your Trusted Partner' },


  ];

  const clonedSlides = [slides[slides.length - 1], ...slides, slides[0]];

  const [currentIndex, setCurrentIndex] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isTransitionEnabled, setIsTransitionEnabled] = useState(true);
  const [dragStartX, setDragStartX] = useState(0);
  const [dragOffsetX, setDragOffsetX] = useState(0);
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);

  const handleNext = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prevIndex) => {
      if (prevIndex === clonedSlides.length - 2) {
        setTimeout(() => {
          setIsTransitionEnabled(false);
          setCurrentIndex(1);
          setIsAnimating(false);
        }, 500);
        return prevIndex + 1;
      }
      return prevIndex + 1;
    });
  }, [isAnimating, clonedSlides.length]);

  const handlePrev = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prevIndex) => {
      if (prevIndex === 1) {
        setTimeout(() => {
          setIsTransitionEnabled(false);
          setCurrentIndex(clonedSlides.length - 2);
          setIsAnimating(false);
        }, 500);
        return prevIndex - 1;
      }
      return prevIndex - 1;
    });
  }, [isAnimating, clonedSlides.length]);

  useEffect(() => {
    intervalRef.current = setInterval(handleNext, 3000);
    return () => clearInterval(intervalRef.current);
  }, [handleNext]);

  useEffect(() => {
    const timer = setTimeout(() => setIsAnimating(false), 500);
    return () => clearTimeout(timer);
  }, [currentIndex]);

  useEffect(() => {
    if (!isTransitionEnabled) {
      const timer = setTimeout(() => setIsTransitionEnabled(true), 50);
      return () => clearTimeout(timer);
    }
  }, [isTransitionEnabled]);

  const handleMouseDown = (e) => {
    setDragStartX(e.clientX);
    setDragOffsetX(0);
  };

  const handleMouseMove = (e) => {
    if (dragStartX !== null) {
      const offset = e.clientX - dragStartX;
      setDragOffsetX(offset);
    }
  };

  const handleMouseUp = (e) => {
    const offset = e.clientX - dragStartX;
    if (offset > 50) {
      handlePrev();
    } else if (offset < -50) {
      handleNext();
    }
    setDragStartX(null);
    setDragOffsetX(0);
  };

  return (
    <div 
      className="slider touch-enabled" 
      ref={sliderRef} 
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <div
        className="slider-container"
        style={{
          transform: `translateX(calc(-${currentIndex * 100}% + ${dragOffsetX}px))`,
          transition: isTransitionEnabled && dragOffsetX === 0 ? 'transform 0.5s ease-in-out' : 'none',
        }}
      >
        {clonedSlides.map((slide, index) => (
          <div className="slider-slide" key={index}>
            <img 
              src={slide.image} 
              alt={slide.text} 
              className="slider-image" 
              loading="lazy" 
              onDragStart={(e) => e.preventDefault()} 
            />
            <div className="slider-text">
              <h2>{slide.text}</h2>
            </div>
          </div>
        ))}
      </div>

      <button className="slider-button prev" onClick={handlePrev} aria-label="Previous Slide">&#10094;</button>
      <button className="slider-button next" onClick={handleNext} aria-label="Next Slide">&#10095;</button>
    </div>
  );
};

export default Slider;